<template>
  <header
    id="navbar"
    :class="[
      'grid-container sticky w-full top-0 z-40 flex-none lg:z-50 ',
      expand ? 'rounded-b-2xl bg-surface elevation-3' : 'surface2',
    ]"
  >
    <div class="h-14 flex justify-center items-center">
      <Link :href="$route('home')">
        <figure id="navbar-logo">
          <Logo class="w-[70px] h-[35px] md:w-[98px] md:h-[56px]" name="full-color-black-accents" />
        </figure>
      </Link>
      <nav
        id="navbar-links"
        class="grow flex flex-row gap-6 justify-end items-center py-1 md:gap-2"
      >
        <div v-if="$window.width > 905" class="hidden md:flex md:flex-row">
          <div v-for="(item, index) in navItemsTextLinks" :key="index">
            <Link
              v-if="item.route_type != 'external'"
              :href="item.route"
              :method="item.method ? item.method : 'get'"
              class="btn-text-link"
            >
              {{ item.label }}
            </Link>
            <a
              v-else
              :href="item.route"
              target="_blank"
              rel="external noopener"
              class="btn-text-link"
            >
              {{ item.label }}
            </a>
          </div>
        </div>
        <div v-if="navItemsButtons.length > 0" class="flex gap-2">
          <Link
            v-for="(item, index) in navItemsButtons"
            :key="index"
            :href="item.route"
            :method="item.method ? item.method : 'get'"
          >
            <Button :class="item.class" :icon="$window.width <= 360 ? '' : item.icon">
              {{ item.label }}
            </Button>
          </Link>
        </div>
        <Link :href="$route('profile')">
          <ProfilePicture
            v-if="!isGuestUser"
            :src="userProfilePictureSrc"
            class="ml-4 hidden md:flex"
            size="small"
            with-border
          />
        </Link>
        <!-- Button to expand/collapse mobile menu -->
        <div class="cursor-pointer md:hidden" @click="expand = !expand">
          <Icon :name="expand ? 'close' : 'menu'" class="fill-primary10" />
        </div>
      </nav>
    </div>
    <div v-if="expand" class="w-full p-2 pb-4">
      <ul class="list-none">
        <ListItemWithDivider v-for="(item, index) in navItemsTextLinks" :key="index">
          <Link
            v-if="item.route_type != 'external'"
            :href="item.route"
            :method="item.method ? item.method : 'get'"
          >
            <Button
              :class="[item.type == 'text-link' ? 'btn-text' : item.class, 'w-full']"
              :icon="item.icon"
            >
              {{ item.label }}
            </Button>
          </Link>
          <a v-else :href="item.route" target="_blank" rel="external noopener" class="btn-text">
            {{ item.label }}
          </a>
        </ListItemWithDivider>
      </ul>
    </div>
  </header>
</template>

<script>
import evalUserProfileType from '@/evalUserProfileType.mixin.js'
import { Link } from '@inertiajs/inertia-vue'
import Logo from '@/Components/Logo'
import Button from '@/Components/Button'
import ProfilePicture from '@/Components/ProfilePicture'
import Icon from '@/Components/Icon'
import ListItemWithDivider from '@/Components/ListItemWithDivider'

export default {
  name: 'TheNavigationBar',
  components: { Link, Logo, Button, ProfilePicture, Icon, ListItemWithDivider },
  mixins: [evalUserProfileType],
  data() {
    return {
      expand: false,
    }
  },
  computed: {
    isCompanySite() {
      return this.$page.url.startsWith('/empresas')
    },
    navigation() {
      const mainSiteBaseNavigation = [
        { route: this.$route('home'), label: 'Inicio', type: 'text-link' },        
        { route: this.$route('search'), label: 'Ofertas', type: 'text-link'},
        { route: this.$route('participante'), label: 'Empresas', type: 'text-link'},
        // { route: '', label: 'Ofertas de Trabajo', type: 'text-link' },
        // { route: '', label: 'Empresas', type: 'text-link' },
      ]

      const companySiteBaseNavigation = [
        { route: this.$route('company.home'), label: 'Inicio', type: 'text-link' },        
        {
          route: this.$route('company.login'),
          label: 'Iniciar sesión',
          type: 'button',
          icon: 'person-outline',
          class: 'btn-filled bg-tertiary-container text-on-tertiary-container fill-currentColor',
        },
        // Remove comment to support company registration
        // {
        //   route: this.$route('company.register'),
        //   label: 'Registrarme',
        //   type: 'button',
        //   icon: 'person-outline',
        //   class: 'btn-filled brand-green fill-currentColor',
        // },
        {
          route: this.$route('home'),
          label: 'Regresar',
          type: 'button',
          icon: 'arrow-back',
          class: 'btn-filled fill-currentColor',
        },
      ]

      if (this.isGuestUser) {
        if (this.isCompanySite) return companySiteBaseNavigation
        else
          return [
            ...mainSiteBaseNavigation,
            {
              route: this.$route('register'),
              label: 'Registrarme',
              type: 'button',
              icon: 'person-outline',
              class: 'btn-filled brand-green fill-currentColor',
            },
            {
              route: 'https://adsbolsadetrabajo.laprensagrafica.com',
              route_type: 'external',
              label: 'Anuncios de LPG',
              type: 'text-link',
            },
            // {
            //   route: this.$route('company.home'),
            //   label: 'Soy empresa',
            //   type: 'button',
            //   icon: 'round-cases',
            //   class: 'btn-filled brand-green fill-currentColor',
            // },
          ]
      } else if (this.isCompanyUser) {
        if (this.isCompanySite)
          return [
            { route: this.$route('home'), label: 'Inicio', type: 'text-link' },
            {
              route: this.$route('company.dashboard'),
              label: 'Ir al Dashboard',
              type: 'button',
              icon: 'round-cases',
              class: 'btn-filled brand-green fill-currentColor',
            },
          ]
        else
          return [
            ...mainSiteBaseNavigation,
            {
              route: this.$route('company.dashboard'),
              label: 'Ir al Dashboard',
              type: 'button',
              icon: 'round-cases',
              class: 'btn-filled brand-green fill-currentColor',
            },
            {
              route: this.$route('company.logout'),
              label: 'Salir',
              type: 'button',
              icon: 'round-log-out',
              method: 'delete',
              class: 'btn-tonal bg-error-container text-on-error-container fill-currentColor',
            },
          ]
      } else if (this.isApplicantUser) {
        if (this.isCompanySite)
          return [
            { route: this.$route('company.home'), label: 'Inicio', type: 'text-link' },
            {
              route: this.$route('home'),
              label: 'Regresar al sitio principal',
              type: 'button',
              icon: 'arrow-back',
              class: 'btn-filled fill-currentColor',
            },
          ]
        else
          return [
            ...mainSiteBaseNavigation,
            { route: '', label: 'Mi perfil', type: 'text-link', route: this.$route('profile') },
          ]
      }
    },
    buttonTypeNavItems() {
      return this.navigation.filter(item => item.type === 'button')
    },
    textLinkTypeNavItems() {
      return this.navigation.filter(item => item.type === 'text-link')
    },
    navItemsButtons() {
      if (this.$window.width < 600) return this.buttonTypeNavItems.slice(0, 1) // Returns first item
      return this.buttonTypeNavItems
    },
    navItemsTextLinks() {
      if (this.$window.width < 600)
        return [...this.textLinkTypeNavItems, ...this.buttonTypeNavItems.slice(1)] // Returns all but first item
      return this.textLinkTypeNavItems
    },
    userProfilePictureSrc() {
      if (this.isGuestUser) return null
      return this.isCompanyUser ? this._profile.logo_url : this._profile.profile_picture_url
    },
  },
}
</script>
